<mat-form-field>
  <mat-label>{{ label }}</mat-label>

  <mat-select [formControl]="control" [required]="isRequired(control)">
    <mat-option [value]="null">-</mat-option>

    @for (option of options; track $index) {
      <mat-option [value]="option">{{ option.name }}</mat-option>
    }
  </mat-select>

  @if (control.invalid) {
    <mat-error>{{ control.errors | json }}</mat-error>
  }
</mat-form-field>
